import { Component, computed, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { FlowNode } from '@features/flow-ui-creator/interfaces/flow-ui.interface';
import { NodeData, NodeEditorAnnotationParameter } from '@features/flow-ui-creator/interfaces/node.interface';
import { NzResizableModule, NzResizeEvent } from 'ng-zorro-antd/resizable';
import { ReteModule } from 'rete-angular-plugin/21';
import { BaseNodeComponent } from '../base-node/base-node.component';

@Component({
  selector: 'app-annotation-node',
  imports: [ReteModule, NzResizableModule],
  templateUrl: './annotation-node.component.html',
  styleUrl: './annotation-node.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    'data-testid': 'node',
    class: 'resizable-node',
  },
})
export class AnnotationNodeComponent
  extends BaseNodeComponent<FlowNode<NodeData<[NodeEditorAnnotationParameter]>>>
  implements OnInit
{
  protected readonly editorElement = this.flowService.nodeEditorElement;
  protected readonly minWidth = computed(() => {
    const { z = 1 } = this.flowService.getAreaHolderTranslateXY();
    const minWidth = this.width() > 200 ? 200 : this.width();

    return minWidth * z;
  });

  protected readonly minHeight = computed(() => {
    const { z = 1 } = this.flowService.getAreaHolderTranslateXY();
    const minHeight = this.height() > 100 ? 100 : this.height();

    return minHeight * z;
  });

  protected width = signal<number>(200);
  protected height = signal<number>(100);
  protected id = -1;

  ngOnInit(): void {
    this.width.set(this.data.nodeData?.parameters?.[0].min || 200);
    this.height.set(this.data.nodeData?.parameters?.[0].max || 100);

    this.cdr.detectChanges();
  }

  onResize({ width, height }: NzResizeEvent): void {
    cancelAnimationFrame(this.id);
    this.id = requestAnimationFrame(() => {
      const { z } = this.flowService.getAreaHolderTranslateXY();

      this.width.set(Math.floor(width / z));
      this.height.set(Math.floor(height / z));

      if (!this.data.nodeData.parameters?.length) {
        this.data.nodeData.parameters = [
          {
            min: this.width(),
            max: this.height(),
          },
        ];
      } else {
        this.data.nodeData.parameters[0].min = this.width();
        this.data.nodeData.parameters[0].max = this.height();
      }

      this.cdr.detectChanges();
    });
  }
}
